// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Branding tier types matching backend enum
 */
export type BrandingTier = 'NONE' | 'GREY_LABEL' | 'WHITE_LABEL';

/**
 * Branding configuration returned from backend
 * Matches BrandingService.resolveBranding() response
 */
export interface BrandingConfig {
  logoUrl: string;
  brandingTier: BrandingTier;
  showPoweredByBadge: boolean;
  colors?: {
    primary?: string;
    secondary?: string;
    [key: string]: string | undefined;
  };
  typography?: {
    fontFamily?: string;
    [key: string]: string | undefined;
  };
  spacing?: Record<string, string | number>;
  /** Provider display name — set by the public (login page) branding lookup */
  displayName?: string;
  [key: string]: unknown;
}

/**
 * Public provider branding from the Provider Server
 * (`GET /api/config/branding?providerCode=`).
 */
export interface ProviderBrandingResponse {
  providerCode: string;
  providerName: string;
  displayName: string | null;
  logoUrl: string | null;
  brandingConfig: Record<string, unknown> | null;
}

/**
 * Default platform branding (fallback)
 */
export const DEFAULT_BRANDING: BrandingConfig = {
  logoUrl: '/logo.svg',
  brandingTier: 'NONE',
  showPoweredByBadge: false,
  colors: {
    primary: '#2185d0',
    secondary: '#1678c2'
  }
};
